<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre2"><br/>
<br/>
<br/>
<br/>
<br/>
<br/></p>
<p class="calibre2 sgc-6"><i class="calibre4">This is the ultimate purpose: to let God in. But we can let him in only where we really stand, where we live, where we live a true life. If we maintain holy intercourse with the little world entrusted to us, if we help the holy spiritual substance to accomplish itself in that section of Creation in which we are living, then we are establishing, in this our place, a dwelling for the Divine Presence</i>.</p>
<p class="calibre2 sgc-15">—Martin Buber</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FrontOther01.vue?4b511322